import {Component} from '@angular/core';
/**
 * \@title Complex Example
 */
export class TabsTemplateLabelExample {static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'tabs-template-label-example',
  templateUrl: 'tabs-template-label-example.html',
  styleUrls: ['./tabs-template-label-example.css']
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function TabsTemplateLabelExample_tsickle_Closure_declarations() {
/** @type {?} */
TabsTemplateLabelExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TabsTemplateLabelExample.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
